










export default {
    name: 'AccountVerificationPanel',

    computed: {
        emailIsVerified() {
            return Boolean(this.$auth.user?.email_verified);
        },
    },

    mounted() {
        localStorage.setItem('email_verified', 'false');

        window.addEventListener('storage', this.onStorageUpdate);
    },

    destroyed() {
        window.removeEventListener('storage', this.onStorageUpdate);
    },

    methods: {
        async resendEmail() {
            await this.$store
                .dispatch('requestVerificationEmail')
                .then((response) => {
                    if (response === 204) {
                        this.$toast.show({
                            type: 'info',
                            message: 'Email has already been verified',
                        });
                    } else if (response === 202) {
                        this.$toast.show({
                            type: 'success',
                            message: 'Verification email has been sent.',
                        });
                    }
                })
                .catch((error) => {
                    this.$toast.show({
                        type: 'error',
                        message: 'Verification email failed to send.',
                        primary: {
                            label: 'Try again',
                            action: () => this.resendEmail(),
                        },
                    });
                });
        },

        async onStorageUpdate(event) {
            if (event.key === 'email_verified') {
                await this.$auth.fetchUser();
            }
        },
    },
};
